import { render } from "./Welcome.vue?vue&type=template&id=54660228"
import script from "./Welcome.vue?vue&type=script&lang=js"
export * from "./Welcome.vue?vue&type=script&lang=js"

import "./Welcome.vue?vue&type=style&index=0&id=54660228&lang=css"
script.render = render

export default script